<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="sources"
      class="elevation-10 pa-10"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("source.title") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            :label="$t('common.search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer />
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="mb-2 d-none d-sm-flex"
            @click="addItem()"
          >
            {{ $t("source.button.add") }}
            <v-icon right dark> mdi-plus-circle</v-icon>
          </v-btn>
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="d-flex d-sm-none"
            @click="addItem()"
          >
            <v-icon dark> mdi-plus-circle</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mx-2" @click="showItem(item)"> mdi-eye</v-icon>
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="editItem(item)"
        >
          mdi-pencil</v-icon
        >
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="deleteItem(item)"
        >
          mdi-delete</v-icon
        >
      </template>
      <template v-slot:[`item.publicationYear`]="{ item }">
        <span>{{ $d(new Date(item.publicationYear)) }}</span>
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import router from "@/router";
import { storeToRefs } from "pinia";
import { useSourceStore } from "@/store/sourceStore";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";

export default {
  data: function () {
    return {
      store: useSourceStore(),
      userStore: useUserStore(),
      search: ref(""),
      sources: null,
      headers: [
        { text: this.$t("source.list.header.id"), value: "id" },
        { text: this.$t("source.list.header.title"), value: "title" },
        { text: this.$t("source.list.header.author"), value: "author" },
        {
          text: this.$t("source.list.header.publicationYear"),
          value: "publicationYear",
        },
        {
          text: this.$t("source.list.header.action"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  beforeMount() {
    this.sources = storeToRefs(this.store).sources;
    this.store.getSources();
  },
  props: {
    title: String,
  },
  methods: {
    addItem() {
      this.store.$reset();
      router.push({ path: "/source/add" });
    },

    showItem(item) {
      this.store.$reset();
      router.push(`source/${item.id}`);
    },

    editItem(item) {
      this.store.$reset();
      router.push(`source/edit/${item.id}`);
    },

    deleteItem(deleteItem) {
      if (confirm(this.$t("source.delete.confirm"))) {
        this.store.deleteSource(deleteItem.id);
      }
    },
  },
};
</script>
